"use client";
import cn from "clsx";
import { Box, Card, Text, Button, TextField } from "@radix-ui/themes";
import * as Label from "@radix-ui/react-label";
import * as Form from "@radix-ui/react-form";
import { useTranslations } from "next-intl";
import { AlertProps, LayoutProps, TransitionType } from "@/components/layout/layoutType";
import { useForm } from "react-hook-form";
import { getApiHostname } from "@/util/paramutil";
import { useContext, useEffect, useState } from "react";
import GoogleLoginButton from "./googleLogin";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { fetchHost, fetchUtil } from "@/util/fetchutil";
import { Debug } from "@/util/debug";
import { AlertContext } from "@/components/context/alertContext";
import { Capacitor } from "@capacitor/core";
import AppleLoginButton from "./appleLogin";
import { defaultLocale } from "@/i18n/routing";
import { checkEmpty } from "@/util/stringutil";
import { alertLoading } from "../list/defaultType";

// const signin_google_link =
//   "https://accounts.google.com/o/oauth2/auth?client_id=" +
//   process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID +
//   "&redirect_uri=" +
//   process.env.NEXT_PUBLIC_GOOGLE_CLIENT_CALLBACK +
//   "&response_type=code&scope=https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile";

export const checkLoginCommon = (ta: TransitionType, locale: any, alert_p: ((prop: AlertProps) => void) | undefined, getData: any) => {
  if (getData.status == "OK") {
    loginSuccess(locale);
  } else {
    loginFailed(ta, alert_p);
  }
};

export const loginSuccess = (locale: any) => {
  if (location.pathname === (locale === defaultLocale || checkEmpty(locale) ? "" : "/" + locale) + "/user/signin") {
    location.href = "/";
  } else {
    location.reload();
  }
};
export const loginFailed = (ta: TransitionType, alert_p: ((prop: AlertProps) => void) | undefined) => {
  if (alert_p) {
    alert_p({
      open: true,
      title: ta("signin_denied"),
      description: ta("signin_denied_detail"),
      useCancel: false,
      useOk: true,
      cancelTitle: undefined,
      okTitle: undefined,
    });
  } else {
    alert("alert is null");
  }
};
export default function Signin({ params }: { params?: LayoutProps }) {
  const { register, handleSubmit } = useForm();
  const ta = useTranslations("alert");
  const alertContext = useContext(AlertContext);

  const alert_p = alertContext.setProp;
  const checkLogin = (getData: any) => checkLoginCommon(ta, params?.locale, alert_p, getData);

  const onSubmit = async (data: any) => {
    //console.log(data);
    // const saltRounds = 10;
    // const salt = await bcrypt.genSalt(saltRounds);
    // const password = await bcrypt.hash(data.password, salt);
    if (data.userid.trim() === "" || data.password.trim() === "") {
      return;
    }

    if (alert_p) {
      alert_p(alertLoading);
    }

    fetchHost(
      "/api/sign/signin",
      {
        mode: "cors",
        method: "POST",
        headers: { "Content-type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          user_id: data.userid,
          user_pass: data.password,
        }),
      },
      undefined,
      (getData: any) => {
        Debug(getData);
        checkLogin(getData);
      },
    );

    fetch(getApiHostname() + "/api/sign/signin", {
      mode: "cors",
      method: "POST",
      headers: { "Content-type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        user_id: data.userid,
        user_pass: data.password,
      }),
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          loginFailed(ta, alert_p);
          throw new Error("network error : " + res.status);
        }
      })
      .then((getData) => {
        Debug(getData);
        checkLogin(getData);
      })
      .catch((error) => {
        loginFailed(ta, alert_p);
        //setOpen(true);
      });
  };
  const clientId =
    Capacitor.getPlatform() === "web"
      ? (process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID ?? "")
      : Capacitor.getPlatform() === "ios"
        ? (process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID_IOS ?? "")
        : (process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID_ANDROID ?? "");
  return (
    <Box maxWidth="720px" className="m-auto min-w-[80%] lg:min-w-[50%]">
      {params != null && params.user != null ? (
        <div className="flex flex-col p-6 text-center">
          <h3 className="whitespace-nowrap tracking-tight text-2xl font-bold" data-id="3">
            {ta("signin_already")}
          </h3>
        </div>
      ) : (
        <Card className={cn("text-card-foreground shadow-sm my-12")}>
          <Form.Root className="FormRoot" onSubmit={handleSubmit(onSubmit)}>
            <div className="flex flex-col p-6">
              <h3 className="whitespace-nowrap tracking-tight text-2xl font-bold px-[13px]" data-id="3">
                {ta("signin")}
              </h3>
              <p className="text-sm text-muted-foreground px-[13px] mb-8" data-id="4"></p>
              <GoogleOAuthProvider clientId={clientId}>
                <GoogleLoginButton loginFn={checkLogin} />
              </GoogleOAuthProvider>
              <AppleLoginButton loginFn={checkLogin} />
            </div>
          </Form.Root>
        </Card>
      )}
    </Box>
  );
}
